export const UPDATE_HBS_PROPERTIES = "UPDATE_HBS_PROPERTIES";

const initialState = { isHbsPopupOpen: false, isHbsApiAvailable: true };

export default (state = initialState, action) => {
  if (action.type === UPDATE_HBS_PROPERTIES) {
    return {
      ...state,
      ...action.payload
    };
  }
  return state;
};
